export default __webpack_public_path__ + "static/media/rounds-img.e1905b77.svg";